import React, {useEffect, useState} from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Link } from 'react-router-dom';
import moment from 'moment';

const DatePicker = (props) => {
  const { selectedDate, locationName, params } = props;
  const [showMenu, setShowMenu] = useState(false);
  const [selected, setSelected] = useState(selectedDate);
  let enforceMinDate = true;
  let numOfDays = 7;

  function hideShowMenu() {
    setShowMenu(!showMenu);
  }

  useEffect(() => {
    setSelected(selectedDate);
  }, [selectedDate])

  function getDay(date) {
    let text = date.format("MMMM D");
    let today = new moment();
    if (date.isSame(today, 'day')) {
      text = "Today";
    }
    else if (date.isSame(moment(today).subtract(1, 'day'), 'day')) {
      text = "Yesterday"
    }
    else if (date.isSame(moment(today).add(1, 'day'), 'day')) {
      text = "Tomorrow"
    }
    let location = locationName;
    let selectedDate = date.format('/YYYY/M/D/');
    let selectedMeal = params.meal ? params.meal : '';
    let day = <Link to={"/" + location + selectedDate + selectedMeal} key={text} className="datepicker-item" onClick={() => hideShowMenu()} ><div>{text}</div></Link>;
    return day;
  }

  let daysArray = [];
  let today = new moment();
  let minDate = moment(today).startOf('week').subtract(1, 'day');
  let maxDate = moment(today).endOf('week').add(7, 'day');
  let guard = -1;
  while (daysArray.length < numOfDays && guard < 14) {
    let tempDate = moment(selected).add(guard, 'day');
    guard++;
    if (tempDate.isAfter(minDate) || enforceMinDate === false) {
      if (tempDate.isBefore(maxDate)) {
        daysArray.push(getDay(tempDate));
      }
    }
  }
  let menu = showMenu ? <div className="datepicker-menu">{daysArray}</div> : null;
  return (
    <div className="datepicker-container">
      {showMenu ? <div className="obfusicator" onClick={hideShowMenu}></div> : false}
      <div className="datepicker" onClick={hideShowMenu}>
        {selected.format("MMMM D, YYYY")}
        {showMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </div>
      {menu}
    </div>
  )
}

export default DatePicker;